import styled from 'styled-components';

interface rowProps {
	margin?: string;
	padding?: string;
	marginBottom?: string;
	alignItemsStart?: boolean;
	projectIndividualScreenBlock?: boolean;
	recentProjectsBlock?: boolean;
	recentArchivesBlock?: boolean;
}
const Row = styled.div<rowProps>`
	display: flex;
	flex-wrap: wrap;
	margin-right: -15px;
	margin-left: -15px;
	padding: ${({ padding }) => padding}!important;
	margin: ${({ margin }) => margin}!important;
	margin-bottom: ${({ marginBottom }) => marginBottom}!important;
	${({ alignItemsStart }) =>
		alignItemsStart &&
		`align-items: flex-start;
	`}
	${({ projectIndividualScreenBlock }) =>
		projectIndividualScreenBlock &&
		`@media screen and (max-width: 640px) {
			flex-direction: column;
		}
	`}
	${({ recentProjectsBlock }) =>
		recentProjectsBlock &&
		`padding-right: 10px;
		padding-left: 10px;
		justify-content: center;
		margin-top:16px;
		div{
			width: auto;
			overflow: hidden;
			margin: 0 10px 10px;
			img{
				width: 168px;
				height: 140px;
				object-fit: scale-down;
			}
		}
	`}
	${({ recentArchivesBlock }) =>
		recentArchivesBlock &&
		`padding-right: 10px;
		padding-left: 10px;
		justify-content: center;
		margin-top:16px;
		flex-wrap:wrap;
		div{
			overflow: hidden;
			margin: 0 10px 10px;
			width: calc(100%/4 - 20px);
			@media (max-width: 960px){
				width: calc(100%/3 - 20px);
			}
			@media (max-width: 767px){
				width: calc(100%/2 - 20px);
			}
			@media (max-width: 592px){
				width: calc(100%/1 - 20px);
			}
			img{
				width: 100%;
				height: auto;
				object-fit: fill;
			}
		}
		.archivesContentBlock{
			width:100%;
			h1{
				color:#8C8C8C;
				font-family: 'RubikMedium'!important;
				font-size: 15px;
				span{
					color: #000000;
					font-family: 'RubikMedium'!important;

				}
				+ h1{
					margin-top:5px!important;
				}

			}
		}
		.archivesBtnBlock{

			display:flex;
			align-items:center;
			width: auto!important;
			button {
				font-family: 'RubikMedium' !important;
				font-size: 12px;
				line-height: 18px;
				border-radius: 3px;
				height: auto;
				width: auto;
				height: 30px;
				padding:0 15px;
				background: #2D9CDB;
				text-decoration: none!important;
				margin: 10px 0 6px 5px!important;

				img{
					width:20px;
					margin-right:5px;
				}

				+ button {
					margin-right: 12px!important;
					background: #ffffff;
					border: 1px solid #2D9CDB;
					color:#2D9CDB!important;
				}
			}
		}

	`}
	
	&.row-card {
		.column-card {
			width: 25%;
			flex-basis: auto;
			flex-grow: unset;
			@media screen and (max-width: 1440px) {
				width: 33.333%;
			}
			@media screen and (max-width: 1024px) {
				width: 50%;
			}
			@media screen and (max-width: 767px) {
				width: 100%;
			}
		}
	}
`;
export default Row;
